module.exports = __webpack_public_path__ + "img/dia_das_criancas.403816ea.svg";